/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import { CalculadoraProvisao } from '@finx/web-repository/src/types/Provisao'
import { LocalExecucao, ProvisaoDados, Procedimento, Funcao, Calculadora, FontePagadora,
         Operadora, ProcedimentoCalculadora, ProfissionaisExecutantes, PerfilProfissionalExecutante } from '@/types/_'
import { StateProvisao } from '@/types/interfaces/StateProvisao'
import { Apis, Factories, Services} from '@finx/web-repository'

Vue.use(Vuex)

const dialogDadosIniciais: Boolean = false
const dialogInformacoesAdicionais: Boolean = false
const dialogFuncao: Boolean = false
const dialogResumo: Boolean = false
const contratoId: String = ''
const isEditProvisao = false
const getShow = false
const user = ''

const perfilProfissionalExecutante: PerfilProfissionalExecutante = {
  contratoId: '',
  isAssistente: false,
  isGestor: true,
  isProfissionalExecutante: false,
  visualizaValores: false
}

const stateProvisao: StateProvisao = {
    bloquearDadosIniciais: false,
    dadosIniciaisColorStatus: 'secondary',
    bloquearFuncoesProcedimentos: true,
    funcoesColorStatus: 'secondary',
    bloquearResumoProcedimentos: true,
    bloquearInformacoesAdicionais: true,
    informacoesAdicionaisColorStatus: 'secondary',
}

const procedimentos: Procedimento[] = []

const dados: ProvisaoDados = {
  isProvisaoValido: false,
  contratoId: '',
  dadosIniciais: {
    nomePaciente: '',
    dataProcedimento: '',
    fontePagadoraSelected: '',
    fontePagadoraId: '',
    fontesPagadoras: [],
    prestadorId: '',
    localExecucaoSelected: '',
    localExecucaoId: '',
    locaisExecucoes: [],
    operadoraSelected: '',
    operadoraId: '',
    operadoras: [],
    planoOperadoraId: '',
    planoOperadoraNome: '',
    contratoGrupoRemuneracaoId: ''
  },
  informacoesAdicionais: {
    tipoAtendimento: false, //Boolean
    tipoAcomodacao: 2, //Number
  },
  calculadora: {
    valorCirurgiao: 0,
    valorAnestesista: 0,
    valorInstrumentador: 0,
    valorauxiliares: {
      auxiliar1: 0,
      auxiliar2: 0,
      auxiliar3: 0,
      auxiliar4: 0,
    },
    valorTotal: 0,
    procedimentos: []
  }
}

const funcao: Funcao = {
  userLogged: '',
  userCodLogged: 0,
  cirurgiao: '',
  anestesista: '',
  instrumentador: '',
  auxiliares: {
    auxiliar1: '',
    auxiliar2: '',
    auxiliar3: '',
    auxiliar4: '',
  },
  profissionaisExecutantes : []
}

const getters = {
  USER: (state: any) => state.user,
  PERFIL_PROFISSIONAL_EXECUTANTE: (state: any) => state.perfilProfissionalExecutante,
  STATE_PROVISAO: (state: any) =>  state.stateProvisao,
  BLOQUEAR_DADOS_INICIAIS: (state: any) => {
    return !(state.dados.dadosIniciais.FONTE_PAGADORA_ID !== '' &&
            state.dados.dadosIniciais.LOCAL_EXECUCAO_ID !== '' &&
            state.dados.dadosIniciais.NOME_PACIENTE !== '' &&
            state.dados.dadosIniciais.DATA_PROCEDIMENTO !== '' &&
            state.dados.dadosIniciais.PLANO_OPERADORA_ID !== '')
  },
  BLOQUEAR_FUNCOES_PROCEDIMENTOS: (state: any) => {

    if(state.procedimentos.length === 0) {
      return true
    }

    if(!state.procedimentos.some(p => p.aplicaUrgencia) && !state.procedimentos.some(p => p.aplicaAcomodacao)) {
      return false
    }

    return state.stateProvisao.bloquearFuncoesProcedimentos
  },
  BLOQUEAR_RESUMO_PROCEDIMENTOS: (state: any) => state.stateProvisao.bloquearResumoProcedimentos,
  BLOQUEAR_INFORMACOES_ADICIONAIS: (state: any) => {
    if(state.procedimentos.length === 0) {
      return true
    }

    if(!state.procedimentos.some(p => p.aplicaUrgencia) && !state.procedimentos.some(p => p.aplicaAcomodacao)) {
      return true
    }

    return state.stateProvisao.bloquearInformacoesAdicionais
  },
  DIALOG_DADOS_INICIAIS: (state: any) => state.dialogDadosIniciais,
  DIALOG_FUNCAO: (state: any) => state.dialogFuncao,
  DIALOG_INFORMACOES_ADICIONAIS: (state: any) => state.dialogInformacoesAdicionais,
  DIALOG_RESUMO: (state: any) => state.dialogResumo,
  PROVISAO: (state: any) => state.dados,
  CONTRATO_ID: (state: any) => state.dados.contratoId,
  APLICA_INSTRUMENTADOR: (state: any) : Boolean => state.procedimentos.some(c => c.aplicaInstrumentador === true),
  APLICA_ANESTESICO: (state: any): Boolean => state.procedimentos.some(c => c.aplicaAnestesico === true),
  APLICAR_ACOMODACAO: (state: any): Boolean => state.procedimentos.some(c => c.aplicaAcomodacao === true),
  APLICAR_TIPO_ATENDIMENTO: (state: any): Boolean => state.procedimentos.some(c => c.aplicaUrgencia === true),
  TIPO_ATENDIMENTO: (state: any): Boolean => state.dados.informacoesAdicionais.tipoAtendimento,
  TIPO_ACOMODACAO: (state: any): Number => state.dados.informacoesAdicionais.tipoAcomodacao,
  FONTES_PAGADORAS: (state: any) => state.dados.dadosIniciais.fontesPagadoras,
  FONTE_PAGADORA_SELECTED: (state: any) => state.dados.dadosIniciais.fontePagadoraSelected,
  FONTE_PAGADORA_ID: (state: any) => state.dados.dadosIniciais.fontePagadoraId,
  LOCAIS_EXECUCOES: (state: any) => state.dados.dadosIniciais.locaisExecucoes,
  LOCAL_EXECUCAO_SELECTED: (state: any) => state.dados.dadosIniciais.localExecucaoSelected,
  LOCAL_EXECUCAO_ID: (state: any) => state.dados.dadosIniciais.localExecucaoId,
  OPERADORAS: (state: any) => state.dados.dadosIniciais.operadoras,
  OPERADORA_SELECTED: (state: any) => state.dados.dadosIniciais.operadoraSelected,
  OPERADORA_ID: (state: any) => state.dados.dadosIniciais.operadoraId,
  PRESTADOR_ID: (state: any) => state.dados.dadosIniciais.prestadorId,
  PLANO_OPERADORA_ID:(state: any) => state.dados.dadosIniciais.planoOperadoraId,
  DATA_PROCEDIMENTO: (state: any) => state.dados.dadosIniciais.dataProcedimento,
  NOME_PACIENTE: (state: any) => state.dados.dadosIniciais.nomePaciente,
  PROCEDIMENTOS: (state: any) : Procedimento[] => state.procedimentos,
  FUNCAO: (state: any) : Funcao => state.funcao,
  CALCULADORA: (state: any) : Calculadora => state.dados.calculadora,
  PROFISSIONAIS_EXECUTANTES: (state: any) => state.funcao.profissionaisExecutantes,
  PROVISAO_VALIDO: (state: any) => state.dados.isProvisaoValido,
  CONTRATO_GRUPO_REMUNERACAO: (state: any) => state.dados.dadosIniciais.contratoGrupoRemuneracaoId,
  PROVISAO_VALOR_TOTAL: (state: any) => state.dados.calculadora.valorTotal,
  IS_EDIT_PROVISAO: (state: any) => state.isEditProvisao,
  DADOS_INICIAIS_STATUS_COLOR: (state: any) => state.stateProvisao.dadosIniciaisColorStatus,
  INFORMACOES_ADICIONAIS_STATUS_COLOR: (state: any) => state.stateProvisao.informacoesAdicionaisColorStatus,
  FUNCOES_STATUS_COLOR: (state: any) => state.stateProvisao.funcoesColorStatus
}

const actions = {
  LOAD_FUNCAO_USER_LOGGED: async ({commit, getters}, contratoId: String) => {
    const request = await Apis.Contratos.ProfissionaisExecutantes.getPapelProfissionalExecutante(getters.USER.profile.sub, contratoId)
    const success = Factories.Apis.success(request)
    if (success) {
      commit('SET_PERFIL_PROFISSIONAL_EXECUTANTE', request.data)
    }
  },
  LOAD_PROVISAO: async ({ commit, getters, dispatch }, provisaoId) => {

    commit('RESET_PROVISAO')
    commit('RESET_PROCEDIMENTOS')

    await Apis.Legacy.Producao.getProducaoById(provisaoId).then(async (response) => {
      const success = response.status;
      if(success) {
        var responseProvisao = response.data

        commit('CONTRATO_ID', responseProvisao.contratoId)

        const request = await Apis.Contratos.ProfissionaisExecutantes.getPapelProfissionalExecutante(getters.USER.profile.sub, responseProvisao.contratoId)
        const success = Factories.Apis.success(request)
        if (success) {
          commit('SET_PERFIL_PROFISSIONAL_EXECUTANTE', request.data)
        }

        const editProvisao:  ProvisaoDados = {
          contratoId: responseProvisao.contratoId,
          isProvisaoValido: true,
          dadosIniciais: {
            nomePaciente: responseProvisao.nomePaciente,
            dataProcedimento: responseProvisao.dataRealizacao,
            fontePagadoraId: responseProvisao.fontePagadoraId,
            prestadorId: responseProvisao.prestadorId,
            localExecucaoId: responseProvisao.localExecucaoId,
            operadoraId: responseProvisao.operadoraId,
            planoOperadoraNome: responseProvisao.planoOperadoraNome,
            planoOperadoraId: responseProvisao.planoOperadoraId,
            fontePagadoraSelected: '',
            fontesPagadoras: getters.FONTES_PAGADORAS,
            locaisExecucoes: [],
            localExecucaoSelected: '',
            operadoraSelected: '',
            operadoras: [],
            contratoGrupoRemuneracaoId: ''
          },
          informacoesAdicionais: {
            tipoAcomodacao: responseProvisao.acomodacao !== undefined && responseProvisao.acomodacao !== null  ? responseProvisao.acomodacao === 'Apartamento' ? 1 : 2 : null,
            tipoAtendimento: responseProvisao.urgente !== undefined && responseProvisao.urgente !== null ? responseProvisao.urgente : null
          },
          calculadora: {
            valorCirurgiao: 0,
            valorAnestesista: 0,
            valorInstrumentador: 0,
            valorauxiliares: {
              auxiliar1: 0,
              auxiliar2: 0,
              auxiliar3: 0,
              auxiliar4: 0,
            },
            valorTotal: 0,
            procedimentos: []
          }
        }

        const sortProcedimentos =
        responseProvisao.procedimentos.sort((n1, n2) => {
          if (n1.sequencial > n2.sequencial) {
            return 1;
          }
          if (n1.sequencial < n2.sequencial) {
              return -1;
          }
          return 0 })

          for(var i= 0; i < sortProcedimentos.length; i++) {
            await Apis.Contratos.Procedimentos.getProcedimentosProvisaoByProcedimentoId(sortProcedimentos[i].contratoProcedimentoId)
              .then(async (request) => {
                if(request.data !== '') {
                  request.data.viaAcesso = sortProcedimentos[i].viaAcesso,
                  request.data.quantidade = sortProcedimentos[i].quantidade
                  request.data.sequencial = sortProcedimentos[i].sequencial

                  dispatch('SET_PROCEDIMENTO_SELECTED', request.data)
                }
              })
          }

          await Apis.Contratos.ProfissionaisExecutantes.getProfissionalExecutanteByContratoId(responseProvisao.contratoId)
          .then(async (request) => {
            const success = Factories.Apis.success(request)
            if (success) {
              const funcaoEdit: Funcao = {
                userLogged: '',
                userCodLogged: 0,
                cirurgiao: '',
                anestesista: '',
                instrumentador: '',
                auxiliares: {
                  auxiliar1: '',
                  auxiliar2: '',
                  auxiliar3: '',
                  auxiliar4: '',
                },
                profissionaisExecutantes: []
              }

              request.data.map(c => {
                var legacy = responseProvisao.profissionaisExecutantes.filter(p => p.id === c.id)[0]
                if(legacy !== undefined) {
                  c.status = false
                  switch(legacy.funcao) {
                    case 'Cirurgiao':
                      c.funcao = 0
                      funcaoEdit.cirurgiao = c
                      if (getters.USER.profile.sub === legacy.id) {
                        funcaoEdit.userLogged = 'cirurgiao'
                        funcaoEdit.userCodLogged = 0
                      }
                      break
                    case 'PrimeiroAuxiliar':
                      if (getters.PROCEDIMENTOS.some(p => p.quantidadeAuxiliarPermitido > 0)) {
                        c.funcao = 1
                        funcaoEdit.auxiliares.auxiliar1 = c
                        if (getters.USER.profile.sub === legacy.id) {
                          funcaoEdit.userLogged = 'auxiliar1'
                          funcaoEdit.userCodLogged = 1
                        }
                      } else {
                        c.status = true
                      }

                      break
                    case 'SegundoAuxiliar':
                      if (getters.PROCEDIMENTOS.some(p => p.quantidadeAuxiliarPermitido > 1)) {
                        c.funcao = 2
                        funcaoEdit.auxiliares.auxiliar2 = c
                        if (getters.USER.profile.sub === legacy.id) {
                          funcaoEdit.userLogged = 'auxiliar2'
                          funcaoEdit.userCodLogged = 2
                        }
                      } else {
                        c.status = true
                      }
                      break
                    case 'TerceiroAuxiliar':
                      if (getters.PROCEDIMENTOS.some(p => p.quantidadeAuxiliarPermitido > 2)) {
                        c.funcao = 3
                        funcaoEdit.auxiliares.auxiliar3 = c
                        if (getters.USER.profile.sub === legacy.id) {
                          funcaoEdit.userLogged = 'auxiliar3'
                          funcaoEdit.userCodLogged = 3
                        }
                      } else {
                        c.status = true
                      }
                      break
                    case 'QuartoAuxiliar':
                      if (getters.PROCEDIMENTOS.some(p => p.quantidadeAuxiliarPermitido > 3)) {
                        c.funcao = 4
                        funcaoEdit.auxiliares.auxiliar4 = c
                        if (getters.USER.profile.sub === legacy.id) {
                          funcaoEdit.userLogged = 'auxiliar4'
                          funcaoEdit.userCodLogged = 4
                        }
                      } else {
                        c.status = true
                      }

                      break
                    case 'Instrumentador':
                      if (getters.PROCEDIMENTOS.some(p => p.aplicaInstrumentador)) {
                        c.funcao = 5
                        funcaoEdit.instrumentador = c
                        if (getters.USER.profile.sub === legacy.id) {
                          funcaoEdit.userLogged = 'instrumentador'
                          funcaoEdit.userCodLogged = 5
                        }
                      } else {
                        c.status = true
                      }
                      break
                    case 'Anestesista':
                      if (getters.PROCEDIMENTOS.some(p => p.aplicaAnestesico)) {
                        c.funcao = 6
                        funcaoEdit.anestesista = c
                        if (getters.USER.profile.sub === legacy.id) {
                          funcaoEdit.userLogged = 'anestesista'
                          funcaoEdit.userCodLogged = 6
                        }
                      } else {
                        c.status = true
                      }
                      break
                  }
                }
                else {
                  c.status = true
                }

                funcaoEdit.profissionaisExecutantes.push(c)
              })

              if (request.data !== undefined) {
                commit('SET_FUNCAO', funcaoEdit)
              }
            }
          })

        commit('SET_TIPO_ACOMODACAO',editProvisao.informacoesAdicionais.tipoAcomodacao)
        commit('SET_TIPO_ATENDIMENTO',editProvisao.informacoesAdicionais.tipoAtendimento)
        dispatch('CALCULADORA_PROVISAO')
        commit('SET_EDIT_PROVISAO', editProvisao)
        commit('SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS', false)
        commit('SET_BLOQUEAR_INFORMACOES_ADICIONAIS', !responseProvisao.procedimentos.some(p => p.acomodacao !== null) &&
                                                      !responseProvisao.procedimentos.some(p => p.urgente !== null))
        commit('SET_BLOQUEAR_RESUMO_PROCEDIMENTOS', false)
      }
    })
  },
  HABILITAR_ENVIO_PROVISAO: ({commit, state, getters}) => {
    const profissionalExecutanteSelected = getters.FUNCAO.profissionaisExecutantes.some(c => c.status === false)
    if (getters.PROCEDIMENTOS.length === 0) {
      commit('SET_HABILITAR_ENVIO_PROVISAO', false)
      return
    }

    if (getters.PROCEDIMENTOS.length ===  1 && profissionalExecutanteSelected) {
      commit('SET_HABILITAR_ENVIO_PROVISAO', true)
    }
    else {
      const procedimento = getters.PROCEDIMENTOS.filter(c => c.quantidade === undefined || c.quantidade === 0 || c.viaAcesso === undefined || c.viaAcesso === null)
      commit('SET_HABILITAR_ENVIO_PROVISAO', (getters.PROCEDIMENTOS.length > 0 && profissionalExecutanteSelected))
    }
  },
  CALCULADORA_PROVISAO: async ({ commit, state, getters }) => {
    if (state.procedimentos.length > 0) {
      let funcaoUsuarioLogado = ''

      state.funcao.profissionaisExecutantes.map((p) => {
        if (getters.USER.profile.sub === p.id) {
          switch (p.funcao) {
            case 0:
              funcaoUsuarioLogado = 'ProfissionalPrincipal '
              break
            case 1:
              funcaoUsuarioLogado = 'PrimeiroAuxiliar'
              break
            case 2:
              funcaoUsuarioLogado = 'SegundoAuxiliar'
              break
            case 3:
              funcaoUsuarioLogado = 'TerceiroAuxiliar'
              break
            case 4:
              funcaoUsuarioLogado = 'QuartoAuxiliar'
              break
            case 5:
              funcaoUsuarioLogado = 'Instrumentador'
              break
            case 6:
              funcaoUsuarioLogado = 'Anestesista'
              break
            default:
              break
          }
        }
      })

      const p = state.procedimentos.reduce((prev, current) => (prev.quantidadeAuxiliarPermitido > current.quantidadeAuxiliarPermitido ? prev : current))
      const calculadora : CalculadoraProvisao = {
        contratoId: state.dados.contratoId,
        profissionalPrincipal: (state.funcao.cirurgiao !== '' && state.funcao.cirurgiao !== null),
        anestesista: (state.funcao.anestesista !== '' && state.funcao.anestesista !== null),
        instrumentador: (state.funcao.instrumentador !== '' && state.funcao.instrumentador !== null),
        primeiroAuxiliar: (state.funcao.auxiliares.auxiliar1 !== '' && state.funcao.auxiliares.auxiliar1 !== null),
        segundoAuxiliar: (state.funcao.auxiliares.auxiliar2 !== '' && state.funcao.auxiliares.auxiliar2 !== null),
        terceiroAuxiliar: (state.funcao.auxiliares.auxiliar3 !== '' && state.funcao.auxiliares.auxiliar3 !== null),
        quartoAuxiliar: (state.funcao.auxiliares.auxiliar4 !== '' && state.funcao.auxiliares.auxiliar4 !== null),
        Urgente: state.procedimentos.some(c => c.aplicaUrgencia === true) ? state.dados.informacoesAdicionais.tipoAtendimento !== '' ? state.dados.informacoesAdicionais.tipoAtendimento : false : false,
        acomodacao: state.procedimentos.some(c => c.aplicaAcomodacao === true) ? state.dados.informacoesAdicionais.tipoAcomodacao !== '' ? state.dados.informacoesAdicionais.tipoAcomodacao : 2 : 2,
        funcaoUsuarioLogado: funcaoUsuarioLogado !== '' ? funcaoUsuarioLogado : null,
        procedimentos: [],
      }

      state.procedimentos.map((c) => {
        calculadora.procedimentos.push(c)
      })

      await Apis.Contratos.Calculadora.calculoProvisao(calculadora).then((request) => {
        const success = Factories.Apis.success(request)
        if (success) {
          commit('SET_VALOR_CIRURGIAO', request.data.calculoConsolidado.valorProfissionalPrincipal)
          commit('SET_VALOR_ANESTESISTA', request.data.calculoConsolidado.valorAnestesista)
          commit('SET_VALOR_INSTRUMENTADOR', request.data.calculoConsolidado.valorInstrumentador)
          commit('SET_VALOR_AUXILIAR1', request.data.calculoConsolidado.valorPrimeiroAuxiliar)
          commit('SET_VALOR_AUXILIAR2', request.data.calculoConsolidado.valorSegundoAuxiliar)
          commit('SET_VALOR_AUXILIAR3', request.data.calculoConsolidado.valorTerceiroAuxiliar)
          commit('SET_VALOR_AUXILIAR4', request.data.calculoConsolidado.valorQuartoAuxiliar)
          commit('SET_VALOR_PROCEDIMENTO_CALCULADORA', request.data.procedimentos)
          commit('SET_VALOR_TOTAL_CALCULADORA', request.data.total)
        }
      })
    }
  },
  LOAD_FONTESPAGADORAS: ({ commit }, fontesPagadoras: Array<FontePagadora>) => {
    commit('LOAD_FONTESPAGADORAS', fontesPagadoras)
  },
  LOAD_OPERADORAS: ({ commit }, operadoras: Array<Operadora>) => {
    commit('LOAD_OPERADORAS', operadoras)
  },
  LOAD_LOCAISEXECUCOES: ({ commit }, locaisExecucoes: Array<LocalExecucao>) => {
    commit('LOAD_LOCAISEXECUCOES', locaisExecucoes)
  },
  SET_USER: ({ commit }, value) => {
    commit('SET_USER', value)
  },
  SET_PERFIL_PROFISSIONAL_EXECUTANTE: ({ commit }, perfil: PerfilProfissionalExecutante) => {
    commit('SET_PERFIL_PROFISSIONAL_EXECUTANTE', perfil)
  },
  SET_IS_EDIT_PROVISAO: ({ commit }, value: Boolean) => {
    commit('SET_IS_EDIT_PROVISAO', value)
  },
  SET_EDIT_FONTEPAGADORA: ({ commit }, fontePagadoraSelected) => {
    commit('SET_EDIT_FONTEPAGADORA', fontePagadoraSelected)
  },
  SET_EDIT_LOCALEXECUCAO_SELECTED: ({ commit }, fontePagadoraSelected) => {
    commit('SET_EDIT_LOCALEXECUCAO_SELECTED', fontePagadoraSelected)
  },
  SET_EDIT_OPERADORA_SELECTED: ({ commit }, operadoraSelected) => {
    commit('SET_EDIT_OPERADORA_SELECTED', operadoraSelected)
  },
  SET_FONTEPAGAFORA_SELECTED: ({ commit }, fontePagadoraSelected) => {
    commit('SET_FONTEPAGAFORA_SELECTED', fontePagadoraSelected)
  },
  SET_LOCALEXECUCAO_SELECTED: ({ commit }, localExecucaoSelected) => {
    commit('SET_LOCALEXECUCAO_SELECTED', localExecucaoSelected)
  },
  SET_OPERADORA_SELECTED: ({ commit }, operadoraSelected) => {
    commit('SET_OPERADORA_SELECTED', operadoraSelected)
  },
  SET_DATA_PROCEDIMENTO: ({ commit }, dataProcedimento: String) => {
    commit('SET_DATA_PROCEDIMENTO', dataProcedimento)
  },
  SET_NOME_PACIENTE: ({ commit }, nomePaciente: String) => {
    commit('SET_NOME_PACIENTE', nomePaciente)
  },
  SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS: ({ commit }, bloquear: Boolean) => {
    commit('SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS', bloquear)
  },
  SET_BLOQUEAR_INFORMACOES_ADICIONAIS: ({ commit }, bloquear: Boolean) => {
    commit('SET_BLOQUEAR_INFORMACOES_ADICIONAIS', bloquear)
  },
  SET_BLOQUEAR_RESUMO_PROCEDIMENTOS: ({ commit }, bloquear: Boolean) => {
    commit('SET_BLOQUEAR_RESUMO_PROCEDIMENTOS', bloquear)
  },
  SET_PROCEDIMENTO_SELECTED: ({ commit }, procedimento: Procedimento) => {
    commit('SET_PROCEDIMENTO_SELECTED', procedimento)
  },
  SET_TIPO_ATENDIMENTO: ({ commit }, selected: Boolean) => {
    commit('SET_TIPO_ATENDIMENTO', selected)
  },
  SET_TIPO_ACOMODACAO: ({ commit }, selected: Boolean) => {
    commit('SET_TIPO_ACOMODACAO', selected)
  },
  SET_VALOR_CIRURGIAO: ({ commit }, valorCirurgiao: Number) => {
    commit('SET_VALOR_CIRURGIAO', valorCirurgiao)
  },
  SET_VALOR_ANESTESISTA: ({ commit }, valorAnestesista: Number) => {
    commit('SET_VALOR_ANESTESISTA', valorAnestesista)
  },
  SET_VALOR_INSTRUMENTADOR: ({ commit }, valorInstrumentador: Number) => {
    commit('SET_VALOR_INSTRUMENTADOR', valorInstrumentador)
  },
  SET_VALOR_AUXILIAR1: ({ commit }, auxiliar1: Number) => {
    commit('SET_VALOR_AUXILIAR1', auxiliar1)
  },
  SET_VALOR_AUXILIAR2: ({ commit }, auxiliar2: Number) => {
    commit('SET_VALOR_AUXILIAR2', auxiliar2)
  },
  SET_VALOR_AUXILIAR3: ({ commit }, auxiliar3: Number) => {
    commit('SET_VALOR_AUXILIAR3', auxiliar3)
  },
  SET_VALOR_AUXILIAR4: ({ commit }, auxiliar4: Number) => {
    commit('SET_VALOR_AUXILIAR4', auxiliar4)
  },
  SET_VALOR_TOTAL_CALCULADORA: ({ commit }, valorTotal: Number) => {
    commit('SET_VALOR_TOTAL_CALCULADORA', valorTotal)
  },
  SET_VALOR_PROCEDIMENTO_CALCULADORA: ({ commit }, procedimento: ProcedimentoCalculadora) => {
    commit('SET_VALOR_PROCEDIMENTO_CALCULADORA', procedimento)
  },
  SET_PROVISAO_VALIDO: ({ commit }, status: Boolean) => {
    commit('SET_PROVISAO_VALIDO', status)
  },
  SET_PROFISSIONAIS_EXECUTANTES: ({ commit }, profissionaisExecutantes: ProfissionaisExecutantes[]) => {
    commit('SET_PROFISSIONAIS_EXECUTANTES', profissionaisExecutantes)
  },
  SET_DIALOG_DADOS_INICIAIS: ({ commit }, status: Boolean) => {
    commit('SET_DIALOG_DADOS_INICIAIS', status)
  },
  SET_FUNCAO: ({ commit }, value: Funcao) => {
    commit('SET_FUNCAO', value)
  },
  SET_PROCEDIMENTOS({ commit }, value: Procedimento[]) {
    commit('SET_PROCEDIMENTOS', value)
  },
  SET_DADOS_INICIAIS_STATUS_COLOR({ commit }, color: String) {
    commit('SET_DADOS_INICIAIS_STATUS_COLOR', color)
  },
  SET_INFORMACOES_ADICIONAIS_STATUS_COLOR({ commit }, color: String) {
    commit('SET_INFORMACOES_ADICIONAIS_STATUS_COLOR', color)
  },
  SET_FUNCOES_STATUS_COLOR({ commit }, color: String) {
    commit('SET_FUNCOES_STATUS_COLOR', color)
  },
  RESET_FUNCAO: ({ commit }) => {
    commit('RESET_FUNCAO')
  },
  RESET_CALCULADORA: ({ commit }) => {
    commit('RESET_CALCULADORA')
  },
  RESET_OPERADORA_SELECTED: ({ commit }) => {
    commit('RESET_OPERADORA_SELECTED')
  },
  RESET_LOCAL_EXECUCAO_SELECTED: ({ commit }) => {
    commit('RESET_LOCAL_EXECUCAO_SELECTED')
  },
  RESET_PROFISSIONAIS_EXECUTANTES: ({ commit }) => {
    commit('RESET_PROFISSIONAIS_EXECUTANTES')
  },
  RESET_PROCEDIMENTOS({ commit }) {
    commit('RESET_PROCEDIMENTOS')
  },
  RESET_INFORMACOES_ADICIONAIS({ commit }) {
    commit('RESET_INFORMACOES_ADICIONAIS')
  },
  REMOVE_PROCEDIMENTO_SELECTED: ({ commit }, index) => {
    commit('REMOVE_PROCEDIMENTO_SELECTED', index)
  },
  RESET_PROVISAO: (context) => {
    context.commit('RESET_PROVISAO')
    context.commit('RESET_CALCULADORA')
    context.commit('RESET_FUNCAO')
    context.commit('RESET_PROFISSIONAIS_EXECUTANTES')
    context.commit('SET_HABILITAR_ENVIO_PROVISAO', false)
    context.commit('RESET_PROCEDIMENTOS')
    context.commit('SET_DIALOG_DADOS_INICIAIS', false)
    context.commit('SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS', true)
    context.commit('SET_BLOQUEAR_RESUMO_PROCEDIMENTOS', true)
    context.commit('SET_BLOQUEAR_INFORMACOES_ADICIONAIS', true)
  },
}

const mutations = {
  SET_USER(state: any, value) {
    state.user = value
  },
  SET_PERFIL_PROFISSIONAL_EXECUTANTE(state: any, perfil: PerfilProfissionalExecutante) {
    state.perfilProfissionalExecutante.contratoId = perfil.contratoId
    state.perfilProfissionalExecutante.visualizaValores = perfil.visualizaValores
    state.perfilProfissionalExecutante.isGestor = perfil.isGestor
    state.perfilProfissionalExecutante.isAssistente = perfil.isAssistente
    state.perfilProfissionalExecutante.isProfissionalExecutante = perfil.isProfissionalExecutante
  },
  SET_IS_EDIT_PROVISAO(state: any, value: Boolean) {
    state.isEditProvisao = value
  },
  SET_HABILITAR_ENVIO_PROVISAO(state: any, status) {
    state.dados.isProvisaoValido = status
  },
  SET_DIALOG_DADOS_INICIAIS(state: any, value) {
    state.dialogDadosIniciais = value
  },
  DIALOG_FUNCAO(state: any, value) {
    state.dialogFuncao = value
  },
  DIALOG_INFORMACOES_ADICIONAIS(state: any, value) {
    state.dialogInformacoesAdicionais = value
  },
  DIALOG_RESUMO(state: any, value) {
    state.dialogResumo = value
  },
  PROVISAO(state: any, value) {
    state.dados = value
  },
  CONTRATO_ID(state: any, value) {
    state.contratoId = value
    state.dados.contratoId = value
  },
  LOAD_FONTESPAGADORAS(state: any, fontesPagadoras: Array<FontePagadora>) {
    state.dados.dadosIniciais.fontesPagadoras = fontesPagadoras
  },
  PROCEDIMENTOS(state: any, p) {
    state.procedimentos = p
  },
  LOAD_LOCAISEXECUCOES(state: any, locaisExecucoes: Array<LocalExecucao>) {
    state.dados.dadosIniciais.locaisExecucoes = locaisExecucoes
  },
  LOAD_OPERADORAS(state: any, operadoras: Array<Operadora>) {
    state.dados.dadosIniciais.operadoras = operadoras
  },
  SET_EDIT_FONTEPAGADORA(state: any, fontePagadoraSelected: any) {
    state.dados.dadosIniciais.fontePagadoraSelected = fontePagadoraSelected
    state.dados.contratoId = fontePagadoraSelected.contratoId
    state.dados.dadosIniciais.fontePagadoraId = fontePagadoraSelected.fontePagadoraId
    state.dados.dadosIniciais.prestadorId = fontePagadoraSelected.prestadorId
  },
  SET_EDIT_LOCALEXECUCAO_SELECTED(state: any, localExecucaoSelected) {
    state.dados.dadosIniciais.localExecucaoSelected = localExecucaoSelected
    state.dados.dadosIniciais.localExecucaoId = localExecucaoSelected.localExecucaoId
    state.dados.dadosIniciais.contratoGrupoRemuneracaoId = localExecucaoSelected.contratoGrupoRemuneracaoId
  },
  SET_EDIT_OPERADORA_SELECTED(state: any, operadoraSelected) {
    state.dados.dadosIniciais.operadoraSelected = operadoraSelected
    state.dados.dadosIniciais.contratoGrupoRemuneracaoId = operadoraSelected.contratoGrupoRemuneracaoId
  },
  SET_FONTEPAGAFORA_SELECTED(state: any, fontePagadoraSelected: any) {
    state.dados.contratoId = fontePagadoraSelected.contratoId
    state.dados.dadosIniciais.fontePagadoraSelected = fontePagadoraSelected
    state.dados.dadosIniciais.fontePagadoraId = fontePagadoraSelected.fontePagadoraId
    state.dados.dadosIniciais.prestadorId = fontePagadoraSelected.prestadorId
    state.dados.dadosIniciais.localExecucaoSelected = ''
    state.dados.dadosIniciais.localExecucaoId = ''
    state.dados.dadosIniciais.locaisExecucoes = []
    state.dados.dadosIniciais.operadoraSelected = ''
    state.dados.dadosIniciais.operadoras = []
    state.dados.dadosIniciais.contratoGrupoRemuneracaoId = ''
    state.dados.dadosIniciais.planoOperadoraId = ''
  },
  SET_LOCALEXECUCAO_SELECTED(state: any, localExecucaoSelected) {
    state.dados.dadosIniciais.localExecucaoSelected = localExecucaoSelected
    state.dados.dadosIniciais.localExecucaoId = localExecucaoSelected.localExecucaoId
    state.dados.dadosIniciais.contratoGrupoRemuneracaoId = localExecucaoSelected.contratoGrupoRemuneracaoId
    state.dados.dadosIniciais.planoOperadoraId = ''
  },
  SET_OPERADORA_SELECTED(state: any, operadoraSelected) {
    state.dados.dadosIniciais.operadoraSelected = operadoraSelected
    state.dados.dadosIniciais.operadoraId = operadoraSelected.operadoraId
    state.dados.dadosIniciais.planoOperadoraId = operadoraSelected.planoOperadoraId
    state.dados.dadosIniciais.contratoGrupoRemuneracaoId = operadoraSelected.contratoGrupoRemuneracaoId
  },
  SET_DATA_PROCEDIMENTO(state: any, dataProcedimento: String) {
    state.dados.dadosIniciais.dataProcedimento = dataProcedimento
  },
  SET_NOME_PACIENTE(state: any, nomePaciente: String) {
    state.dados.dadosIniciais.nomePaciente = nomePaciente
  },
  SET_BLOQUEAR_FUNCOES_PROCEDIMENTOS(state: any, bloquear: Boolean) {
    state.stateProvisao.bloquearFuncoesProcedimentos = bloquear
  },
  SET_BLOQUEAR_RESUMO_PROCEDIMENTOS(state: any, bloquear: Boolean) {
    state.stateProvisao.bloquearResumoProcedimentos = bloquear
  },
  SET_BLOQUEAR_INFORMACOES_ADICIONAIS(state: any, bloquear: Boolean) {
    state.stateProvisao.bloquearInformacoesAdicionais = bloquear
  },
  SET_PROCEDIMENTO_SELECTED(state: any, procedimento: Procedimento) {
    state.procedimentos.push(procedimento)
  },
  SET_TIPO_ATENDIMENTO(state: any, selected: Boolean) {
    state.dados.informacoesAdicionais.tipoAtendimento = selected
  },
  SET_TIPO_ACOMODACAO(state: any, selected: Number) {
    state.dados.informacoesAdicionais.tipoAcomodacao = selected
  },
  SET_VALOR_CIRURGIAO(state: any, valorCirurgiao: Number) {
    state.dados.calculadora.valorCirurgiao = valorCirurgiao
  },
  SET_VALOR_ANESTESISTA(state: any, valorAnestesista: Number) {
    state.dados.calculadora.valorAnestesista = valorAnestesista
  },
  SET_VALOR_INSTRUMENTADOR(state: any, valorInstrumentador: Number) {
    state.dados.calculadora.valorInstrumentador = valorInstrumentador
  },
  SET_VALOR_AUXILIAR1(state: any, auxiliar1: Number) {
    state.dados.calculadora.valorauxiliares.auxiliar1 = auxiliar1
  },
  SET_VALOR_AUXILIAR2(state: any, auxiliar2: Number) {
    state.dados.calculadora.valorauxiliares.auxiliar2 = auxiliar2
  },
  SET_VALOR_AUXILIAR3(state: any, auxiliar3: Number) {
    state.dados.calculadora.valorauxiliares.auxiliar3 = auxiliar3
  },
  SET_VALOR_AUXILIAR4(state: any, auxiliar4: Number) {
    state.dados.calculadora.valorauxiliares.auxiliar4 = auxiliar4
  },
  SET_VALOR_TOTAL_CALCULADORA(state: any, valorTotal: Number) {
    state.dados.calculadora.valorTotal = valorTotal
  },
  SET_VALOR_PROCEDIMENTO_CALCULADORA(state: any, procedimento: ProcedimentoCalculadora) {
    state.dados.calculadora.procedimentos = procedimento
  },
  SET_PROVISAO_VALIDO(state: any, status: Boolean) {
    state.dados.isProvisaoValido = status
  },
  SET_PROFISSIONAIS_EXECUTANTES(state: any, profissionaisExecutantes: ProfissionaisExecutantes[]) {
    profissionaisExecutantes.map(c => c.status = true)
    state.funcao.profissionaisExecutantes = profissionaisExecutantes
  },
  SET_EDIT_PROVISAO(state: any, provisaoDados: ProvisaoDados) {
    state.dados = provisaoDados
  },
  SET_FUNCAO(state: any, f: Funcao) {
    state.funcao = f
  },
  SET_PROCEDIMENTOS(state: any, value: Procedimento[]) {
    state.procedimentos = value
  },
  SET_DADOS_INICIAIS_STATUS_COLOR(state: any, color: String) {
    state.stateProvisao.dadosIniciaisColorStatus = color
  },
  SET_INFORMACOES_ADICIONAIS_STATUS_COLOR(state: any, color: String) {
    state.stateProvisao.informacoesAdicionaisColorStatus = color
  },
  SET_FUNCOES_STATUS_COLOR(state: any, color: String) {
    state.stateProvisao.funcoesColorStatus = color
  },
  RESET_OPERADORA_SELECTED(state: any) {
    state.dados.dadosIniciais.operadoraSelected = ''
  },
  RESET_LOCAL_EXECUCAO_SELECTED(state: any) {
    state.dados.dadosIniciais.localExecucaoSelected = ''
  },
  RESET_PROVISAO(state: any) {
    state.dados.isProvisaoValido = false
    state.dados.contratoId = ''
    state.dados.dadosIniciais.nomePaciente = ''
    state.dados.dadosIniciais.dataProcedimento = ''
    state.dados.dadosIniciais.fontePagadoraSelected = ''
    state.dados.dadosIniciais.fontePagadoraId = ''
    state.dados.dadosIniciais.prestadorId = ''
    state.dados.dadosIniciais.localExecucaoSelected = ''
    state.dados.dadosIniciais.localExecucaoId = ''
    state.dados.dadosIniciais.locaisExecucoes = []
    state.dados.dadosIniciais.operadoraSelected = ''
    state.dados.dadosIniciais.operadoraId = ''
    state.dados.dadosIniciais.operadoras = []
    state.dados.dadosIniciais.planoOperadoraId = ''
    state.dados.dadosIniciais.planoOperadoraNome = ''
    state.dados.dadosIniciais.contratoGrupoRemuneracaoId = ''
    state.dados.informacoesAdicionais.tipoAtendimento = false
    state.dados.informacoesAdicionais.tipoAcomodacao = 2
    state.dados.calculadora.valorCirurgiao = 0
    state.dados.calculadora.valorAnestesista = 0
    state.dados.calculadora.valorInstrumentador = 0
    state.dados.calculadora.valorTotal = 0
    state.dados.calculadora.procedimentos = []
  },
  RESET_FUNCAO(state: any) {
    state.funcao.cirurgiao = ''
    state.funcao.anestesista = ''
    state.funcao.instrumentador = ''
    state.funcao.auxiliares.auxiliar1 = ''
    state.funcao.auxiliares.auxiliar2 = ''
    state.funcao.auxiliares.auxiliar3 = ''
    state.funcao.auxiliares.auxiliar4 = ''
    state.funcao.profissionaisExecutantes.map((c) => { c.status = true })
  },
  RESET_PROFISSIONAIS_EXECUTANTES(state: any) {
    state.funcao.profissionaisExecutantes = []
  },
  RESET_PROCEDIMENTOS(state: any) {
    state.procedimentos = []
  },
  RESET_CALCULADORA(state: any) {
    state.dados.calculadora.valorCirurgiao = 0
    state.dados.calculadora.valorAnestesista = 0
    state.dados.calculadora.valorInstrumentador = 0
    state.dados.calculadora.valorauxiliares.auxiliar1 = 0
    state.dados.calculadora.valorauxiliares.auxiliar2 = 0
    state.dados.calculadora.valorauxiliares.auxiliar3 = 0
    state.dados.calculadora.valorauxiliares.auxiliar4 = 0
    state.dados.calculadora.valorTotal = 0
    state.dados.calculadora.procedimentos = []
  },
  RESET_INFORMACOES_ADICIONAIS(state: any) {
    state.dados.informacoesAdicionais.tipoAcomodacao = 2
    state.dados.informacoesAdicionais.tipoAtendimento = false
  },
  RESET_PERFIL_PROFISSIONAL_EXECUTANTE(state: any) {
    state.perfilProfissionalExecutante.contratoId = ''
    state.perfilProfissionalExecutante.visualizaValores = ''
    state.perfilProfissionalExecutante.isGestor = true
    state.perfilProfissionalExecutante.isAssistente = ''
    state.perfilProfissionalExecutante.isProfissionalExecutante = ''
  },
  REMOVE_PROCEDIMENTO_SELECTED(state: any, index: Number) {
    state.procedimentos.splice(index, 1)

    if (state.procedimentos.length > 0) {
      state.procedimentos[0].quantidade = 1
      state.procedimentos[0].viaAcesso = 1
    }
  },
}

export default new Vuex.Store({
  state: {
    perfilProfissionalExecutante,
    getShow,
    isEditProvisao,
    stateProvisao,
    funcao: { ...funcao },
    procedimentos,
    dialogDadosIniciais,
    dialogFuncao,
    dialogInformacoesAdicionais,
    dialogResumo,
    dados,
    contratoId,
    user,
  },
  getters,
  actions,
  mutations,
})
